export const transformDate = (dateDAjout) => {
  const date = new Date(dateDAjout)
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('mg-MG', options);
  return formattedDate;
}

export const convertDate = (time) => {
  const date = new Date(time);
  const dateActuelle = new Date();
  const heure = date.getHours();
  const minute = date.getMinutes();

  const jour = date.getDate();
  const mois = date.getMonth() + 1; // Les mois commencent à 0, donc ajoutez 1.
  const annee = date.getFullYear();

  // Assurez-vous que le jour et le mois ont toujours deux chiffres
  const jourFormatte = (jour < 10 ? '0' : '') + jour;
  const moisFormatte = (mois < 10 ? '0' : '') + mois;
  const dateFormattee = jourFormatte + '/' + moisFormatte + '/' + annee;

  const jourActuell = dateActuelle.getDate();
  const moisActuell = dateActuelle.getMonth() + 1; // Les mois commencent à 0, donc ajoutez 1.
  const anneeActuell = dateActuelle.getFullYear();

  // Assurez-vous que le jour et le mois ont toujours deux chiffres
  const jourFormatteActuell = (jour < 10 ? '0' : '') + jourActuell;
  const moisFormatteActuell = (mois < 10 ? '0' : '') + moisActuell;
  const dateFormatteeActuell = jourFormatteActuell + '/' + moisFormatteActuell + '/' + anneeActuell;

  return `${dateFormattee === dateFormatteeActuell ? "Anio ny" : `${dateFormattee} tamin'ny`} ${heure}:${minute}`
}
